import { FC, JSX } from 'react';
import { Box, Breadcrumbs, Link, Typography } from '@mui/joy';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';

type BreadcrumbItem = {
  label: string;
  path?: string;
};

type PageBreadcrumbsProps = {
  items: BreadcrumbItem[];
};

export const PageBreadcrumbs: FC<PageBreadcrumbsProps> = ({
  items,
}): JSX.Element => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Box sx={{ px: { xs: 2, md: 0 }, height: '36px' }}>
      <Breadcrumbs
        size="sm"
        aria-label={t('breadcrumbs')}
        separator={<ChevronRightRoundedIcon />}
        sx={{ pl: 0 }}
      >
        <Link
          underline="none"
          color="neutral"
          onClick={() => navigate('/')}
          aria-label={t('Home')}
          sx={{ cursor: 'pointer' }}
        >
          <HomeRoundedIcon />
        </Link>

        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return isLast ? (
            <Typography
              key={index}
              color="primary"
              sx={{ fontWeight: 500, fontSize: 12 }}
            >
              {item.label}
            </Typography>
          ) : (
            <Link
              key={index}
              underline="none"
              color="neutral"
              onClick={() => item.path && navigate(item.path)}
              sx={{ cursor: item.path ? 'pointer' : 'default', fontSize: 12 }}
            >
              {item.label}
            </Link>
          );
        })}
      </Breadcrumbs>
    </Box>
  );
};
